import script from "./TaskSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskSection.vue?vue&type=script&lang=ts&setup=true"

import "./TaskSection.vue?vue&type=style&index=0&id=37882798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37882798"]])

export default __exports__